import React from 'react';
import { Tabs } from 'antd';
import PanelTabCard from '../../../components/Common/PanelTabCard';
import OneOnOneMeetingsTab from './OneOnOneMeetingsTab';
import BootcampMeetingsTab from './BootcampMeetingsTab';
import ReferenceRequestsTab from './ReferenceRequestsTab';
import IncomingReferenceRequestsTab from './IncomingReferenceRequestsTab';
import ReceivedReferencesTab from './ReceivedReferencesTab';

const { TabPane } = Tabs;

const AppointmentsTab: React.FC = () => {
  return (
    <PanelTabCard
      title="Randevularım"
      description="1-1 görüşmeler, bootcamp ve referans talepleriniz."
    >
      <Tabs defaultActiveKey="one-on-one" size="large">
        <TabPane tab="1-1 Görüşmelerim" key="one-on-one">
          <OneOnOneMeetingsTab />
        </TabPane>
        <TabPane tab="Bootcampler" key="bootcamps">
          <BootcampMeetingsTab />
        </TabPane>
        <TabPane tab="Referans Talepleri" key="reference-requests">
          <ReferenceRequestsTab />
        </TabPane>
        <TabPane tab="Gelen Referans Talepleri" key="incoming-reference-requests">
          <IncomingReferenceRequestsTab />
        </TabPane>
        <TabPane tab="Bana Yazılan Referanslar" key="received-references">
          <ReceivedReferencesTab />
        </TabPane>
      </Tabs>
    </PanelTabCard>
  );
};

export default AppointmentsTab;
